import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBetslip = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20.5 24.37",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Icon - Betslip",
		children: /* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			"data-name": "Group 70",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M19.75 22.662a.5.5 0 0 1-.5.5.5.5 0 0 1-.325-.12L14.25 20.75l-3.7 2.774a.5.5 0 0 1-.6 0l-3.7-2.774-4.675 2.292a.5.5 0 0 1-.7-.055.5.5 0 0 1-.12-.325V1.75a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1Z",
					"data-name": "Shape 594"
				}),
				/* @__PURE__ */ _jsx("path", {
					strokeLinejoin: "round",
					d: "M5.25 5.75h8.5",
					"data-name": "Shape 596"
				}),
				/* @__PURE__ */ _jsx("path", {
					strokeLinejoin: "round",
					d: "M5.25 9.75h10",
					"data-name": "Shape 597"
				}),
				/* @__PURE__ */ _jsx("path", {
					strokeLinejoin: "round",
					d: "M5.25 13.75h6.5",
					"data-name": "Shape 598"
				})
			]
		})
	})
});
export { SvgIconBetslip as ReactComponent };
